import { Flex, Spinner } from '@chakra-ui/react'

export const PageSpinner = () => {
  return (
    <Flex justifyContent='center' mt='10'>
      <Spinner emptyColor='gray.300' size='lg' speed='0.65s' thickness='3px' />
    </Flex>
  )
}
